import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import components
import { Fragment } from "react";
import Skeleton from "@mui/material/Skeleton";
import Spacer from "../../../components/atoms/Spacer/index.js";
import { SINGLE } from "../../../constants/numbers.consts.js";
export const SkeletonAtomComponent = ({ amount = 1, gap = 4, slots, ...props }) => {
    const Root = slots?.root ?? Fragment;
    return (_jsx(Root, { children: Array.from({ length: amount }).map((_, i) => (_jsxs(Fragment, { children: [_jsx(Skeleton, { "data-testid": "Skeleton", ...props }), amount > SINGLE && gap > 0 && i + SINGLE !== amount && _jsx(Spacer, { "data-testid": "SkeletonSpacer", spacing: gap })] }, i))) }));
};
export default SkeletonAtomComponent;
